import VideoContainer from './VideoContainer'


export default VideoContainer
